export default {
  header: 'Nåværende steg',
  done: 'Ferdig',
  inProgress: 'I gang',
  notStarted: 'Ikke startet',
};
